import React from "react";
import { Box, ListItem, Skeleton } from "@mui/material";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";
const PriceConfigurationSkeleton = () => {
  const { colors } = useTheme();
  return (
    <>
      {Array.from({ length: 10 }).map((_, index) => (
        <ListItem
          key={index}
          sx={{
            padding: "0.75rem 1rem",
            minHeight: "5.25rem",
            borderBottom: "1px solid " + colors?.border?.default,
          }}
          secondaryAction={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.62rem",
              }}
            >
              <Skeleton
                variant="text"
                width={40}
                height={20}
              />
              <Skeleton
                variant="circular"
                width={32}
                height={32}
              />
            </Box>
          }
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: "1rem",
              width: "100%",
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              sx={{ width: "100%" }}
            >
              <Skeleton
                variant="text"
                width="30%"
                height={24}
              />
              <Skeleton
                variant="text"
                width="50%"
                height={20}
                sx={{ marginTop: "0.5rem" }}
              />
              <Skeleton
                variant="text"
                width="40%"
                height={18}
                sx={{ marginTop: "0.5rem" }}
              />
            </Box>
          </Box>
        </ListItem>
      ))}
    </>
  );
};

export default PriceConfigurationSkeleton;
